<template>
  <svg
    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
    width="78"
    height="78"
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="39" cy="39" r="39" fill="white" />
    <path
      d="M33 25L54 39L33 53V25Z"
      fill="#F2A527"
      stroke="#F2A527"
      stroke-width="5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>
